import "./Loader.scss";
import Spinner from 'react-bootstrap/Spinner';

const Loader = () => {
  return (
    <section className="loader">
      <div className="content_wrap p_t p_b">
      <Spinner animation="border" />
      </div>
    </section>
  );
};

export default Loader;
